<!-- Footer -->
<footer>
  <div class="container text-center">
    <p class="image">
      <a href="https://w3.accelya.com/" target="_blank" >
        <b class="poweredby">Powered by
          <img src="assets/landing/img/Accelya_Logo_Digital.png" class="nr5-img">
        </b>
      </a>
    </p>
    <p class="link">
      <span class="bgc-link"> &copy; Copyright {{year}} Accelya Holding World S.L. and its subsidiaries </span>
    </p>
  </div>
</footer>
